<div class="modal__content">
  <div class="closeModalContainer">
    <ui-icon
      class="icon-cancel"
      name="cancel"
      (click)="closeModal()"
      color="black"
      align="right"
    ></ui-icon>
  </div>

  <div class="information-container">
    <div class="qrCodeImage">
      <qrcode
        [qrdata]="urlToDownload"
        [allowEmptyString]="true"
        [cssClass]="'center'"
        [colorDark]="'#000000'"
        [colorLight]="'#ffffff'"
        [elementType]="'canvas'"
        [errorCorrectionLevel]="'M'"
        [margin]="0"
        [scale]="1"
        [width]="216"
      ></qrcode>
    </div>
    <div class="circle-label">
      <ui-text color="blue-500" size="subtitle" weight="bold" align="center">
        Escanea este QR
      </ui-text>
    </div>
    <div class="circle-label-subtitle">
      <ui-text color="blue-500" size="subtitle" weight="light" align="center">
        Así podrás descargar nuestra APP y seguir tu proceso.
      </ui-text>
    </div>
    <div class="w-full">
      <ui-button
        class="modal__button"
        type="primary"
        label="Entendido"
        (clicked)="closeModal()"
      ></ui-button>
    </div>
  </div>
</div>
